// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vm13","left":"styles_left__3QZZ8"};